import React from 'react';
import dayjs from 'dayjs';

import Text from '~components/atoms/Text';
import ActionButton from '~components/atoms/ActionButton';

import combinedActions from '~redux/combinedActions';
import { useAppDispatch, useAppSelector } from '~redux/hooks';
import { FundTypeEnum, GoldTypeEnum, MetalTypeEnum, SilverTypeEnum } from '~utils/enums';

import SummaryPDF from './SummaryPDF';
import * as SummaryStyles from './_customerManagementCreateCollateralSummary.module.scss';

const CustomerManagementCreateCollateralSummaryModal = () => {
    const dispatch = useAppDispatch();

    const collateralParams = useAppSelector((state) => state.customer.createCollateralParams);
    const customerDetails = useAppSelector((state) => state.customer.customerDetails);
    const goldPrices = useAppSelector((state) => state.gold.buyAndSellGold.goldPrices);
    const selectedMetalType = useAppSelector((state) => state.customer.selectedCollateralMetalType);
    const silverPrices = useAppSelector((state) => state.silver.buyAndSellSilver.silverPrices);

    const inventoryList = useAppSelector((state) => state.gold.allInventories);

    const createCollateralAttempt = useAppSelector((state) => state.customer.loadings.createCollateral);

    const branchCode = useAppSelector(state => state.auth.userDetails.branchCode);
    const branches = useAppSelector(state => state.branch.allBranches);

    const userBranch = branches.find(branch => branch.branchCode === branchCode);

    const userBranchName = userBranch?.branchName ?? '-';

    const getRegisterCategory = () => {
        const product = inventoryList.find(inventory => inventory.productId === collateralParams.productId);

        if (!product) return '-';

        return `${FundTypeEnum[product.fundType]} | ${GoldTypeEnum[product.goldType]?.replace('Gold', ' Gold') || SilverTypeEnum[product.silverType]?.replace('Silver', ' Silver')}`;
    };

    const summaryTable = [
        {
            label: 'Collateral Status',
            value: 'Pending',
        },
        {
            label: 'Collateral Date',
            value: dayjs(new Date()).format('DD/MM/YYYY hh:mm A'),
        },
        {
            label: 'Collateral End Date',
            value: collateralParams.collateralEndDate ? dayjs(collateralParams.collateralEndDate).format('DD/MM/YYYY hh:mm A') : '-',
        },
        // {
        //     label: 'Project Name',
        //     value: buyOrSellGoldParams.projectName ? buyOrSellGoldParams.projectName : '-',
        // },
        {
            label: 'Region Name',
            value: userBranch?.regionName,
        },
        {
            label: 'Branch Name',
            value: userBranchName,
        },
        {
            label: 'Branch Code',
            value: userBranch?.branchCode,
        },
        {
            label: 'Register Category',
            value: getRegisterCategory(),
        },
        {
            label: 'Name of Customer/Company Firm/Association',
            value: customerDetails.name,
        },
        {
            label: 'Identification No.',
            value: customerDetails.idNo,
        },
        {
            label: 'CIF No.',
            value: customerDetails.CIFNo,
        },
        {
            label: 'Price per gram (MYR)',
            value: `RM${
                selectedMetalType === MetalTypeEnum.Silver
                    ? (collateralParams.silverPrice === undefined ? silverPrices?.gbuy ?? '-' : collateralParams.silverPrice)
                    : (collateralParams.goldPrice === undefined ? goldPrices.gbuy : collateralParams.goldPrice)
            }`,
        },
        {
            label: 'Quantity',
            value: collateralParams.amount,
        },
        {
            label: 'Total Amount (MYR)',
            value: `RM${collateralParams.marketValue?.toFixed(2)}`,
        },
    ];

    const productTableHeader = ['Product', 'Price per gram (MYR)'];
    const productTableData = [
        collateralParams.productName,
        selectedMetalType === MetalTypeEnum.Silver
            ? (collateralParams.silverPrice === undefined ? silverPrices?.gbuy ?? '-' : collateralParams.silverPrice)
            : (collateralParams.goldPrice === undefined ? goldPrices.gbuy : collateralParams.goldPrice),
    ];

    const handleSubmitForApproval = () => {
        dispatch(combinedActions.customerCreateCollateralAttempt());
    };

    return (
        <div className={SummaryStyles.container}>
            <table className={SummaryStyles['summary-table']}>
                <tbody>
                    {summaryTable.map((item, index) => {
                        return (
                            <tr key={index}>
                                <td>{item.label}</td>
                                <td>{item.label === 'Serial No.' ? item.value : `: ${item.value}`}</td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>

            <div className={SummaryStyles['product-container']}>
                <Text
                    label='Description'
                    isBold
                />

                <table>
                    <tbody>
                        <tr>
                            {productTableHeader.map((item, index) => (
                                <td key={index}>
                                    {item}
                                </td>
                            ))}
                        </tr>

                        <tr>
                            {productTableData.map((item, index) => (
                                <td key={index}>
                                    {item}
                                </td>
                            ))}
                        </tr>
                    </tbody>
                </table>
            </div>

            <div className={SummaryStyles['button-container']}>
                <SummaryPDF />

                <ActionButton
                    label='Back to Form'
                    onClick={() => dispatch(combinedActions.customerSetIsCreateCollateralFormFilled(false))}
                />

                <ActionButton
                    label='Submit for Approval'
                    onClick={handleSubmitForApproval}
                    isLoading={createCollateralAttempt}
                />
            </div>
        </div>
    );
};

export default CustomerManagementCreateCollateralSummaryModal;
